/**
* Head Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Head Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import Matter from 'matter-js';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'head-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.head-hero' ).each( function( key, val ) {
        const head = $( this ).find( '.head-wrapper' )[0];
        const headTop = $( this ).find( '.adam-head-top' )[0];
        const h1 = $( this ).find( 'h1' )[0];
        const height = $( this ).outerHeight();
        const panelHeight = $( this ).find( '.head-turn' ).height();
        window.scrollRefreshPriority--;

        const pinHead = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            pin: $( this ).find( '.head-turn' )[0],
            start: 'top top',
            end: '=+' + ( panelHeight * 0.6666 ),
            pinSpacing: false,
            refreshPriority: window.scrollRefreshPriority,
            scrub: 0,
            // markers: true,
          },
        } );
        pinHead.to( h1, {opacity: '0', ease: 'linear'}, 0 ); // hide h1
        pinHead.to( head, {rotate: '180deg', ease: 'linear'}, 0 ); // spin head
        pinHead.to( headTop, {rotate: '140deg', ease: 'linear'}, 0 ); // open head

        window.scrollRefreshPriority--;

        const pourContents = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: '=+' + ( panelHeight * 0.6666 ),
            end: '=+' + height,
            scrub: 0,
            refreshPriority: window.scrollRefreshPriority,
            onEnter: ( x, y, z ) => {
              $( '.head-item' ).addClass( 'is-loaded' );
              gameLoop();
            },
            // markers: true,
          },
        } );
      } );

      const groundX = $( '.head-contents' ).innerWidth() / 2;
      const groundY = $( '.head-contents' ).innerHeight() - 5;
      const groundW = $( '.head-contents' ).innerWidth();
      const groundH = 30;

      class Box {
        constructor( world, x, y, w, h, options, el ) {
          // add box to physics simulation
          this.physicsBox = Matter.Bodies.rectangle( x, y, w, h, options );
          Matter.Composite.add( world, this.physicsBox );

          // add DOM box at the same coordinates
          if ( el ) {
            this.div = el;
            // document.body.appendChild( this.div );
            this.div.style.width = w;
            this.div.style.height = h;
            this.width = w;
            this.height = h;
          } else {
            this.div = document.createElement( 'div' );
            this.div.classList.add( 'wall' );
            $( '.head-contents' ).append( this.div );
            this.div.style.width = w + 'px';
            this.div.style.height = h + 'px';
            this.width = w;
            this.height = h;
          }

          this.update();
        }

        update() {
          const pos = this.physicsBox.position;
          const angle = this.physicsBox.angle;
          const degrees = angle * ( 180 / Math.PI );

          const x = this.physicsBox.bounds.min.x;
          const y = this.physicsBox.bounds.min.y;

          this.div.style.transform = `translate(${x}px, ${y}px) rotate(${degrees}deg)`;
        }
      }

      let engine;
      const boxes = [];

      setupMatter();
      addObjects();

      function setupMatter() {
        engine = Matter.Engine.create();
      }

      function getRandomInt( min, max ) {
        min = Math.ceil( min );
        max = Math.floor( max );
        return Math.floor( Math.random() * ( max - min + 1 ) ) + min;
      }

      function addObjects() {
        $( '.head-contents .head-item' ).each( function( key, el ) {
          // const x = Math.floor( Math.random() * groundW );
          const x = groundW / 2;
          const y = Math.random() * - 2000;
          const w = $( el ).outerWidth();
          const h = $( el ).outerHeight();
          boxes.push( new Box( engine.world, x, y, w, h, null, el ) );
        } );

        // Walls
        boxes.push(
            new Box( engine.world, groundX, groundY, groundW, 5, {
              isStatic: true,
            } ),
            new Box( engine.world, 15, groundY / 2, 30, groundY, {
              isStatic: true,
            } ),
            new Box( engine.world, window.innerWidth - 15, groundY / 2, 30, groundY, {
              isStatic: true,
            } ),
        );

        if ( window.innerWidth > 1023 ) {
          boxes.push(
              new Box( engine.world, 0, 0, window.innerWidth / 1.5, groundH, {
                isStatic: true,
              } ),
              new Box( engine.world, window.innerWidth, 0, window.innerWidth / 1.5, groundH, {
                isStatic: true,
              } ),
              new Box( engine.world, window.innerWidth / 1.5, -2000, 30, 400, {
                isStatic: true,
              } ),
              new Box( engine.world, window.innerWidth / 3.25, -2000, 30, 400, {
                isStatic: true,
              } ),
          );
        }
      }

      function gameLoop() {
        // update the physics world
        Matter.Engine.update( engine, 1000 / 60 );
        // update the DOM world
        for ( const b of boxes ) {
          b.update();
        }
        requestAnimationFrame( () => gameLoop() );
      }

      /*
       * Googly Eyes
       */
      const pupils = document.querySelectorAll( '.pupil' );

      for ( let i = 0; i < pupils.length; i++ ) {
        const offset = pupils[i].getBoundingClientRect();
        pupils[i]['centerX'] = offset.left + offset.width/2,
        pupils[i]['centerY'] = offset.bottom;
      }

      function goGoogly( e ) {
        let pointerEvent = e;
        let mouseX = 0;
        let mouseY = 0;

        if ( e.targetTouches && e.targetTouches[0] ) {
          e.preventDefault();
          pointerEvent = e.targetTouches[0];
          mouseX = pointerEvent.pageX;
          mouseY = pointerEvent.pageY;
        } else {
          mouseX = e.clientX + window.pageXOffset,
          mouseY = e.clientY + window.pageYOffset;
        }
        for ( let i = 0; i < pupils.length; i++ ) {
          pupils[i]['radians'] = Math.atan2( mouseX - pupils[i]['centerX'], mouseY - pupils[i]['centerY'] ),
          pupils[i]['degree'] = ( pupils[i]['radians'] * ( 180 / Math.PI ) * -1 );
          pupils[i].style.transform = 'rotate('+ ( pupils[i]['degree'] + 180 ) + 'deg)';
        }
      }

      window.addEventListener( 'mousemove', goGoogly );
      window.addEventListener( 'touchstart', goGoogly );
      window.addEventListener( 'touchmove', goGoogly );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'head-hero', COMPONENT );
} )( app );
